import script from "./SectionLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionLabel.vue?vue&type=script&setup=true&lang=js"

import "./SectionLabel.vue?vue&type=style&index=0&id=b2ec5be8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2ec5be8"]])

export default __exports__